<template>
  <v-sheet color="transparent" width="100%" height="100%">
    <v-sheet
      color="transparent"
      width="100%"
      class="
        white--text
        text-h5 text-sm-h4 text-md-h3 text-lg-h2
        font-weight-bold
        text-center
        pt-6 pt-md-8 pt-lg-12
      "
    >
      <Title>Fale Conosco</Title>
    </v-sheet>

    <v-container class="pt-8 pb-10 pt-lg-12 pb-lg-16">
      <v-row class="mt-2" justify="center">
        <v-col cols="12" md="8" lg="7">
          <Form />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import Form from "../forms/Contact.vue";
import Title from "../widgets/Title.vue";

export default {
  components: {
    Form,
    Title,
  },
};
</script>

<style scoped>
.item-tel .v-btn,
.item-email .v-btn {
  letter-spacing: 0 !important;
}

.btn-contact {
  font-size: 16px;
}
</style>
